import { Injectable } from '@angular/core';
import { Http, Response, Headers, RequestOptions, URLSearchParams } from '@angular/http';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/catch';
import 'rxjs/add/observable/throw';
import { PaginatedList } from './';

@Injectable()
export class GenericHttpService<T> {

  protected apiKey = localStorage.getItem("authorizationData");

   private readonly requestOptions: RequestOptions;

  constructor(private readonly http: Http) {}

   public setApiKey(apiKey: string) {
    this.apiKey = apiKey;
  }

  public getAll(url: string): Observable<Array<T>> {
    return this.http.get(url, this.getRequestOptions())
      .map((response: Response) => response.json() as Array<T>)
      .catch((error: any) => Observable.throw(error.json() || 'Error!'));
  }

  public getAllParam(url: string, obj: any): Observable<Array<T>> {

    const requestOption = this.getRequestOptions();

    if (obj !== null) {
       requestOption.params = obj;
    }

    return this.http.get(url, requestOption)
      .map((response: Response) => <Array<T>>response.json())
      .catch((error: any) => Observable.throw(error.json() || 'Error!'));
  }

  public getAllParamFull(url: string, obj: any): Observable<Array<T>> {

    const requestOption = this.getRequestOptions();

    if (obj !== null) {
      requestOption.params = obj;
    }

    return this.http.get(url, requestOption)
      .map((response: Response) => <Array<T>>response.json())
      .catch((error: Error) => Observable.throw(error));
  }

  public getAllPaginated(url: string, page: number, pageSize: number): Observable<PaginatedList<T>> {

    if (!url.endsWith('/')) {
      url += '/';
    }

    url += `${page}/${pageSize}`;

    return this.http.get(url, this.getRequestOptions())
      .map((response: Response) => <PaginatedList<T>>response.json())
      .catch((error: any) => Observable.throw(error.json() || 'Error!'));
  }

  public post(url: string, obj: T): Observable<T> {
    const payLoad = JSON.stringify(obj);
    return this.http.post(url, payLoad, this.getRequestOptionsContentTypeJson())
      .map((response: Response) => response.json() as T)
      .catch((error: any) => Observable.throw(error.json() || 'Error!'));
  }

  public postAny(url: string, obj: any): Observable<T> {
    const payLoad = JSON.stringify(obj);
    return this.http.post(url, payLoad, this.getRequestOptionsContentTypeJson())
      .map((response: any) => response.json() as T)
      .catch((error: any) => Observable.throw(error.json() || 'Error!'));
  }

  public get(url: string, searchParams?: URLSearchParams): Observable<PaginatedList<T>> {

    const requestOption = this.getRequestOptions();

    if (searchParams !== null) {
       requestOption.params = searchParams;
    }

    return this.http.get(url, requestOption)
      .map((response: Response) => response.json() as PaginatedList<T>)
      .catch((error: any) => Observable.throw(error.json() || 'Error!'));
  }

  public getAny(url: string, searchParams?: URLSearchParams): Observable<any> {

    const requestOption = this.getRequestOptions();

    if (searchParams !== null) {
      requestOption.params = searchParams;
    }

    return this.http.get(url, requestOption)
      .map((response: Response) => response.json())
      .catch((error: any) => Observable.throw(error.json() || 'Error!'));
  }

  public getById(url: string): Observable<T> {
    return this.http.get(url, this.getRequestOptions())
      .map((response: Response) => response.json() as T)
      .catch((error: any) => Observable.throw(error.json() || 'Error!'));
  }

  public put(url: string, t: T): Observable<any> {
    const payLoad = JSON.stringify(t);
    return this.http.put(url, payLoad, this.getRequestOptionsContentTypeJson())
      .map((response: Response) => response.json() as T)
      .catch((error: any) => Observable.throw(error.json() || 'Error!'));
  }

  public putAny(url: string, t: any): Observable<any> {
    const payLoad = t;
    return this.http.put(url, payLoad, this.getRequestOptionsContentTypeJson())
      .map((response: Response) => response.json() as T)
      .catch((error: any) => Observable.throw(error.json() || 'Error!'));
  }

  public delete(url: string, id: any): Observable<any> {
    return this.http.delete(url + `/${id}`, this.getRequestOptions())
      .map((response: Response) => response.json() as T)
      .catch((error: any) => Observable.throw(error.json() || 'Error'));
  }

  protected getHeaders(): Headers {
    const headers = new Headers();
    headers.append('Accept', 'application/json');
    headers.append('npb', 'True');
    headers.append('Authorization', 'Bearer ' + this.apiKey);
    return headers;
  }

  protected getRequestOptions(): RequestOptions {
    const objHeaders = this.getHeaders();
    return new RequestOptions({ headers: objHeaders });
  }

  protected getRequestOptionsContentTypeJson(): RequestOptions {
    const objHeaders = this.getHeaders();
    objHeaders.append('Content-Type', 'application/json');
    return new RequestOptions({ headers: objHeaders });
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/generic-http.service.ts